import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'checkingAccount'
})
export class CheckingAccountPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    value = value.toString();

    if(args==='bank'){
        if(value.length>20){
          return value.substr(0,20) + '...';
        }
    }else if (args==='account'){
      return '...' + value.substr(value.length-4, value.length);
    }
  }

}
